import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isAdminSelector } from '../../../store/auth/selectors';
import useBodyClass from '../../../common/hooks/useBodyClassName';
import { useAccessToken } from '../../../common/hooks/useAccessToken';
import { showLoader, hideLoader } from '../../../store/common/slice';
import { StyledBuildingDashboard } from './BuildingDashboard.styled';
import GeneralBuildingData from './GeneralBuildingData';
import TodayStats from './TodayStats';

const BuildingDashboard = ({ match }) => {
    const isAdmin = useSelector(isAdminSelector);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();
    const { buildingID, partnerID } = match.params;
    const titleData = useSelector(state => state.buildings.titleData);

    document.title = t('titles.dashboard');
    useBodyClass('report');

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <StyledBuildingDashboard>
            <h1 className='page-title text-only'>
                {t('buildings.dashboard_title')}
                {titleData.translationKey && (
                    <div className='building-address'>{t('payments.' + titleData.translationKey, titleData)}</div>
                )}
            </h1>
            <div className='stats-wrapper'>
                <GeneralBuildingData buildingID={buildingID} />
                <TodayStats buildingID={buildingID} />
            </div>
        </StyledBuildingDashboard>
    )
}

export default BuildingDashboard;